var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"range-list"},_vm._l((_vm.items),function(item,index){return _c('div',{key:item.name,class:{'list-item': true, selected: item.selected, active: index === _vm.selected},attrs:{"tabindex":"0"},on:{"click":function($event){return _vm.selectItem(index)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.selectItem(index)}}},[(_vm.isAccordion && _vm.rangetype === 'rating')?_c('star-rating-list-item',{attrs:{"item-data":{
        ...item,
        checkbox: { selected: !!item.selected }
      }}}):(_vm.isAccordion)?_c('check-box-label-list-item',{attrs:{"item-data":{
      ...item,
      checkbox: { selected: !!item.selected }
    }}}):_c('span',[_vm._v(" "+_vm._s(item.label)+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }